import React from 'react';

interface Props {
  children: any;
}

export default (props: Props) => <div className="Box_header">{props.children}</div>;
